import { gql } from "@apollo/client"
import craftApolloClient from "./api/apollo"

import { useContext } from "react"
import { GlobalContext } from './_app'

import Head from "next/head"

import { Header } from "../fuselage/global/header/header"
import { Footer } from '../fuselage/theme/2024/layout/footer/footer'
import { HeaderShim } from '../fuselage/global/header/header'

import handleContentBlocks from "../lib/content-blocks"
import handleSeomaticMeta from "../lib/seomatic"

import { 
    QueryPageHeader,
    QueryText, 
    QueryCards,
    QueryFlipFlops, 
    QueryFloaters, 
    QueryBillboards, 
    QueryBillboardSliders, 
    QueryImpactFigures, 
    QueryVideos,
    QueryForm,
    QueryProfileCarousel,
    QueryOffsetCallout,
    QuerySEO,
    QueryImages,
    QuerySpacer,
    QueryDividers,
    QueryPartners,
	BizzaboPartners
} from "../graphql/queries"




export default function Page ({ entry, partnerData }) {

    const globals = useContext(GlobalContext)

    // console.log('entry:', entry)
    // console.log('aviadevContentBlocks:', entry.aviadevContentBlocks)
  
    return (
        <>

            <Head>
                { handleSeomaticMeta(entry.seomatic) } 
            </Head>

            <Header mainMenu={globals.nodes} />
            <HeaderShim />
            
            { handleContentBlocks(entry.aviadevContentBlocks, null, partnerData) }

            <Footer 
				socialConnections={globals.globalSets[2].socialConnections} 
				contactInfo={globals.globalSets[2].contactDetails[0].body}
				hubspotForm={globals.globalSets[2].hubspotForm[0] ? globals.globalSets[2].hubspotForm[0] : null}
			/>

        </>
    )
}
Page.theme = 'aviadev-2024'


export async function getStaticPaths() {

    const entriesData = await craftApolloClient().query({
        query: gql`
            query Pages {
                entries(site: "${process.env.SITE_HANDLE}", section: "${process.env.SITE_HANDLE}Pages") {
                    slug
                }
            }
        `
    })

    const entries = await entriesData.data.entries

    return {
        paths: entries.map( entry => ({ params: { slug: entry.slug } })),
        fallback: false
    }

}

export async function getStaticProps({ params, preview, previewData }) {

    const entryData = await craftApolloClient( preview, previewData ).query({
        query: gql`
            query Page {
                entry(site: "${process.env.SITE_HANDLE}", slug: "${params.slug}") {
                    ... on ${process.env.SITE_HANDLE}Pages_page_Entry {
                        id
                        title
                        slug
                        ${process.env.SITE_HANDLE}ContentBlocks {
                            ${QueryPageHeader}
                            ${QueryText}
                            ${QueryCards}
                            ${QueryFlipFlops}
                            ${QueryFloaters}
                            ${QueryBillboards}
                            ${QueryBillboardSliders}
                            ${QueryImpactFigures}
                            ${QueryVideos}
                            ${QueryProfileCarousel}
                            ${QueryForm}
                            ${QueryImages}
                            ${QuerySpacer}
                            ${QueryDividers}
                            ${QueryOffsetCallout}
                            ${QueryPartners}
                            ${BizzaboPartners}
                        }
                        ${QuerySEO}
                    }
                }
            }
        `
    })

    const page = entryData


    const partners = await fetch(`https://api.bizzabo.com/api/partners?eventId=${process.env.BIZZABO_EVENT_ID}&size=200`, {
		"method": "GET",
		"headers": {
			"Content-Type": "application/json",
			"Authorization": "Bearer 67f61f9e-e897-4536-914e-3f47286650f9"
		}
	})
	const partnerData = await partners.json()


    return { 
        props: { 
            entry: page.data.entry,
            partnerData: partnerData.content,
        }
    }
}